<template>
	<div>
		<v-col class="registrasi">
			<div class="d-flex justify-space-between">
				<div class="font-size-14 font-weight-bold secondary--text">Upgrade Jaringan</div>
			</div>
			<template v-if="!loaderData">
				<div class="mt-5">
					<v-scroll-x-reverse-transition>
						<v-card class="pa-3 elevation-0 rounded-lg" outlined>
							<v-form ref="formUpgrade" role="form">
								<v-row>
									<v-col cols="12" sm="12" md="12" class="align-stretch px-3 pt-3 px-md-4 pt-md-4">
										<v-row>
											<v-col cols="12">
												<v-row>
													<v-col cols="12" sm="4" md="4" class="mb-2">
														<v-select
														v-if="false"
														:items="serialRegisAvailList"
														item-text="serial_member_serial_id"
														return-object
														no-data-text="Tidak Ada Serial"
														label="Serial"
														color="primary"
														class="input-regis"
														hide-details="auto"
														prepend-inner-icon="mdi-barcode"
														outlined
														dense
														ref="serial"
														v-model="params.serial"
														tabindex="1"
														:error-messages="(errorValidation !== undefined && errorValidation['serial'] !== undefined ) ? [errorValidation['serial']] : []"
														:rules="[rules.inputreq('Serial', params.serial)]"
														@change="selectSerial"
														></v-select>
														<v-text-field
														label="Serial"
														color="primary"
														class="input-regis"
														hide-details="auto"
														prepend-inner-icon="mdi-barcode"
														outlined
														dense
														ref="serial"
														v-model="params.serial"
														tabindex="2"
														:error-messages="(errorValidation !== undefined && errorValidation['serial'] !== undefined ) ? [errorValidation['serial']] : []"
														:rules="[rules.inputreq('Serial', params.serial)]"
														@change="emptyError"></v-text-field>
													</v-col>
													<v-col cols="12" sm="4" md="4" class="mb-2">
														<v-text-field
														label="Pin Serial"
														color="primary"
														class="input-regis"
														hide-details="auto"
														prepend-inner-icon="mdi-key"
														outlined
														dense
														ref="pin_serial"
														v-model="params.pin"
														tabindex="2"
														:error-messages="(errorValidation !== undefined && errorValidation['pin'] !== undefined ) ? [errorValidation['pin']] : []"
														:rules="[rules.inputreq('Pin Serial', params.pin)]"
														@change="emptyError"></v-text-field>
													</v-col>
												</v-row>
											</v-col>
										</v-row>
									</v-col>
								</v-row>

								<v-row justify="center" class="ml-0">
									<v-col cols="6" sm="3" md="2" class="pl-0">
										<v-btn large depressed block color="primary" class="white--text rounded-xl text-capitalize" :disabled="params.serial && params.pin ? false : true" tabindex="27" @click="showConfirm">
											<v-icon>mdi-arrow-right-bold-circle</v-icon>
											<span class="pl-2">Proses</span>
										</v-btn>
									</v-col>
								</v-row>
							</v-form>
						</v-card>
					</v-scroll-x-reverse-transition>
				</div>
			</template>

			<template v-else>
				<div class="mt-5">
					<LoadData :loading="loaderData"></LoadData>
				</div>
			</template>
		</v-col>
		<ModalKonfirmasi ref="modalKonfirmasi" :msg="msgConfirm" @action="processInput"></ModalKonfirmasi>
		<ModalSukses ref="modalSukses" @action="onLogout"></ModalSukses>
	</div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import ModalKonfirmasi from '@/components/modals/vo-general/ModalKonfirmasi'
import ModalSukses from './components/ModalSukses';

export default {
	components: {
		ModalKonfirmasi, ModalSukses
	},
	data() {
		return {
			loaderData: false,
			loading: false,
			params: {
				serial: '',
				pin: '',
			},
			rules: {
				input: [
				v => !!v || 'Tidak boleh kosong'
				],
				inputreq(label, v) { 
					return !!v || label + ' tidak boleh kosong'
				},
			},
			msgConfirm: 'Yakin ingin melakukan Upgrade Jaringan?',
		}
	},
	watch: {
	},
	computed: {
		...mapState('serial', ['serialRegisAvailList']),
		...mapState(['errorValidation']),
	},
	methods: {
		...mapActions('jaringan', ['addUpgrade', 'resetValidation']),
		...mapActions('serial', ['getSerialRegisAvailList']),
		...mapActions('autentikasi', ['logout']),
		...mapMutations(['emptyErrorValidation']),

		async validatePaste(val, type){
			let pasted = await val.clipboardData.getData('text')
			setTimeout(() => {
				if (!parseInt(pasted)) {
					if (type === 'ktp') {
						val.preventDefault()
					} else {
						val.preventDefault()
					}
				}
			})
		},
		reset() {
			this.params = {
				serial: '',
				pin: '',
			}
		},
		getData() {
			this.getSerialRegisAvailList()
		},
		showConfirm() {
			this.$refs.modalKonfirmasi.modalShow()
		},
		emptyError() {
			this.emptyErrorValidation()
		},
		async selectSerial() {
			const selectedSerial = await this.params.serial
			this.params.serial = selectedSerial.serial_member_serial_id
			this.params.pin = selectedSerial.serial_member_serial_pin
		},
		async addUpgradeMitra() {
			this.$refs.modalKonfirmasi.loadingButton()
			let formDataUpgrade = new FormData()
			formDataUpgrade.append('serial', this.params.serial)
			formDataUpgrade.append('pin', this.params.pin)

			this.addUpgrade(formDataUpgrade).then(() => {
				this.emptyErrorValidation()
				this.$refs.modalKonfirmasi.modalHide()
				this.$refs.modalSukses.modalShow()
				this.reset()
			}).catch(() => {
				window.scrollTo(0,0)
				this.$refs.modalKonfirmasi.normalButton()
				this.$refs.modalKonfirmasi.modalHide()
			})
		},
		async processInput() {
			if (this.$refs.formUpgrade.validate()) {
				await this.addUpgradeMitra()
			} else {
				window.scrollTo(0,0)
			}
		},
		onLogout() {
			this.logout().then( () => {
				this.$router.push({ name: 'login' })
			})
		},
	},
	async created() {
		this.loaderData = await true
		this.reset()
		await this.emptyErrorValidation()
		await this.$store.dispatch('setPageTitle', 'Upgrade Jaringan')
		await this.getData()

		setTimeout(() => { 
			this.loaderData = false
		}, 1000)
	}
};
</script>

<style lang="scss" scoped>
.icon-upload-image {
	margin-top: -3.3rem !important;
	margin-left: 9.5rem !important;
}

.btn-zoom {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	background: rgba(0,0,0,0.4);

	&:hover, &:focus {
		background: rgba(0,0,0,0.6);
	}
}
</style>